import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const stockOpnameRBAC = {
  pageID: 'f663990bd6da99ea67b5375c6cf9cf85',
  elementID: {
    ViewPage: '30d1007d64bfaea089c3834584b565eb',
    BuatTaskBaru: '7f6c18ff7f58d3cb4a9bcc1b3d5a5696',
    DetailSTO: '30f793f6a3ae987752f70b96a864eea4',
    AksiAssign: '3830b4f8c8fe5c38d2ad4129434fcb8e',
    AksiBatalkan: 'c0cdd86e796f0471ccd32c8c0752191d',
    AksiPrintStockOpname: '495076132e6f0471ca600691882ed9d1',
    AksiReassign: 'b6618d8af16f04718a494f4acfdead39',
    AksiRecount: '0cdc0d2e2cfb79eb3af40acc7540cf83',
    AksiReview: '74fd1a37ecfe5c38d2ad1119fb8304b9',
    AksiSubmit: 'e36b3453239a77b1435dee7acfe6ada3',
    AksiAdjust: '8b8819021111b9afc71dcd1b5a6a0380',
    AksiPrintPreviewReport: '940d1d039f8070da8efc028d2d6a37a2',
    AksiCountList: '83f66c044cad7bf3d49a591dd1bec8e4',
    AksiPrintAdjustmentReport: '61ff33a82843bbdf6bcb3d374b8a00ac',
    AksiPrintWriteOffReport: 'e897dd36ba008b87cb532ea9adb0a69e',
    AksiPrintPreviewExcelReport: 'bc24e058b95dd8c66c78f1eec2025799',
    AksiPrintAdjustmentExcelReport: '70e31437fc7e087baa022d5b5e062253',
    AksiPrintWriteOffExcelReport: '27fec36c8041ac8744416518bee263ed',
  },
} as const

export const useRBACStockOpnamePage = createUseRBAC(stockOpnameRBAC.elementID)

export type UseRBACStockOpnamePageType = ReturnType<typeof useRBACStockOpnamePage>
